export function addTargetBlankToAnchors(htmlString: string) {
  return htmlString.replace(/<a\s+(?!.*?target=)/gi, '<a target="_blank" ');
}
